module.exports = __webpack_public_path__ + "img/positive_1.2d4ff53c.png";